import { render, staticRenderFns } from "./OptionArticleForm.vue?vue&type=template&id=15275fef"
import script from "./OptionArticleForm.vue?vue&type=script&lang=ts"
export * from "./OptionArticleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports